import { Heading1 } from 'components/shared/Typography.styled';
import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  screen,
  spacing
} from 'theme';

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  padding: ${spacing('xl5')} ${spacing('md')};
  margin: auto;
  ${Heading1} {
    text-align: center;
  }
`;

export const StyledIntro = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};
  margin-bottom: ${spacing('xl5')};

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    gap: ${spacing('mdlg')};
  }
`;

export const StyledIntroImage = styled.div`
  max-width: 100%;
  flex-shrink: 0;
  border-radius: ${radius('lg')};
  overflow: hidden;

  @media (min-width: ${screen('md')}) {
    max-width: 50%;
  }

  @media (min-width: ${screen('lg')}) {
    max-width: 30rem;
  }

  img {
    display: block;
    border-radius: ${radius('lg')};
  }
`;

export const StyledIntroTitle = styled.h3`
  color: ${color('text_subtle')};
  font-weight: ${fontWeight('extraBold')};
  text-transform: uppercase;
  margin-top: 0;
`;

export const StyledSummary = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${spacing('mdlg')};
  margin-top: ${spacing('xl')};
`;

export const StyledSummaryValue = styled.div`
  font-family: ${fontFamily('display')};
  font-size: ${fontSize('xl6')};
  line-height: 1;
  font-weight: ${fontWeight('semiBold')};
  text-transform: uppercase;
`;

export const StyledSummaryItem = styled.div`
  max-width: 24rem;
  background-color: ${color('sand_100')};
  border-radius: ${radius('md')};
  padding: ${spacing('lg')};
  line-height: 1.5;
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs')};

  @media (min-width: ${screen('md')}) {
    max-width: 17rem;
  }

  p {
    margin: 0;
  }

  &:first-child ${StyledSummaryValue} {
    color: ${color('indigo_500')};
  }
  &:nth-child(2) ${StyledSummaryValue} {
    color: ${color('sun_900')};
  }
  &:nth-child(3) ${StyledSummaryValue} {
    color: ${color('mint_900')};
  }
  &:nth-child(4) ${StyledSummaryValue} {
    color: ${color('cyan_700')};
  }
  &:nth-child(5) ${StyledSummaryValue} {
    color: ${color('purple_700')};
  }
  &:nth-child(6) ${StyledSummaryValue} {
    color: ${color('positive_500')};
  }
`;

export const StyledText = styled.div`
  line-height: 1.5;

  &:not(.display-full-text) {
    display: -webkit-box;
    -webkit-line-clamp: 12;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
  }

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
`;

export const StyledShowMore = styled.div`
  margin-top: ${spacing('lg')};
  padding: 0;
  display: flex;
  align-items: center;
  gap: ${spacing('xs')};
  position: relative;
  width: 100%;

  button {
    padding: 0;
    background: transparent;
    border: 0;
    display: flex;
    align-items: center;
    gap: ${spacing('xs')};
    cursor: pointer;
  }

  svg {
    flex-shrink: 0;
    width: 1.25rem !important;
    height: 1.25rem;
    color: ${color('text_default')};
  }

  span {
    flex-shrink: 0;
    color: ${color('link')};
    font-weight: ${fontWeight('black')};
    text-transform: uppercase;
    font-size: ${fontSize('sm')};
    line-height: 1;

    @media (min-width: ${screen('lg')}) {
      font-size: ${fontSize('md')};
    }
  }

  &::before {
    content: '';
    flex-grow: 1;
    height: 1px;
    background-color: ${color('midnight_200')};
  }

  &::after {
    content: '';
    flex-grow: 1;
    height: 1px;
    background-color: ${color('midnight_200')};
  }
`;
